import script from "./RangeSectionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeSectionsView.vue?vue&type=script&setup=true&lang=js"

import "./RangeSectionsView.vue?vue&type=style&index=0&id=ef2f1e9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef2f1e9c"]])

export default __exports__